import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import Certification from "@/pages/Certification";
import Portal from "@/pages/Portal";
import TrainingHub from "@/pages/TrainingHub";
import CompanyPortal from "@/pages/CompanyPortal";
import CoursePlayer from "@/pages/CoursePlayer";
import Verify from "@/pages/Verify";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/certification" element={<Certification />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/portal" element={<Portal />} />
      <Route path="/training" element={<TrainingHub />} />
      <Route path="/company" element={<CompanyPortal />} />
      <Route path="/training/course/:assignmentId" element={<CoursePlayer />} />
      <Route path="/verify" element={<Verify />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster theme="dark" richColors position="top-right" />
    </div>
  );
}

export default App;
